<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'subsectors.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="subsectorsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'subsectors',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'name',
        title: 'Nome'
      },
      {
        field: 'code',
        title: 'Código'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'subsectors.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('subsectors.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
